import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const HubSpotTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't load HubSpot tracking on job detail pages or thank you pages
    const isJobDetailPage = /^\/careers\/[a-f0-9-]{36}$/i.test(location.pathname);
    const isThankYouPage = location.pathname === "/application-thank-you";
    
    if (isJobDetailPage || isThankYouPage) {
      console.log("[HubSpot] Tracking excluded for job application flow");
      return;
    }

    // Check if HubSpot is already loaded
    if (document.getElementById("hs-script-loader")) {
      return;
    }

    // Load HubSpot tracking script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = "//js-na1.hs-scripts.com/43692900.js";
    document.body.appendChild(script);

    console.log("[HubSpot] Tracking script loaded");

    return () => {
      // Cleanup: Remove script if component unmounts
      const existingScript = document.getElementById("hs-script-loader");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [location.pathname]);

  return null;
};
